var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStationLocator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.91602C14.4186 2.91602 8.25 8.81563 8.25 16.0645C8.25 19.5166 9.82352 24.1073 12.9267 29.7096C15.4189 34.2076 18.3021 38.275 19.8017 40.2988C20.0551 40.6446 20.3864 40.9259 20.7688 41.1197C21.1512 41.3136 21.5739 41.4146 22.0026 41.4146C22.4313 41.4146 22.854 41.3136 23.2363 41.1197C23.6187 40.9259 23.95 40.6446 24.2034 40.2988C25.7005 38.275 28.5863 34.2076 31.0784 29.7096C34.1765 24.1091 35.75 19.5183 35.75 16.0645C35.75 8.81563 29.5814 2.91602 22 2.91602Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2551 19.1954H28.9444C29.3221 19.1944 29.6668 19.386 29.8276 19.6883C29.9884 19.9907 29.9367 20.3475 29.6944 20.6041L19.3279 31.6541C19.1341 31.8446 18.8213 31.9 18.5603 31.7892C18.2993 31.6784 18.1517 31.4285 18.2002 31.1757L20.3058 21.7309H15.0504C14.7553 21.7289 14.4766 21.6094 14.2927 21.4052C14.1088 21.202 14.0394 20.9356 14.1033 20.6809L16.9226 9.63769C17.0184 9.24687 17.4083 8.96785 17.8609 8.96591H25.2198C25.5259 8.96202 25.8145 9.08938 25.9951 9.30715C26.1823 9.51812 26.2428 9.79616 26.1591 10.0538L23.2551 19.1954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationLocator);
export default __webpack_public_path__ + "static/media/station-locator.ec956e3b12dcd6ededc8cd924232a6c8.svg";
export { ForwardRef as ReactComponent };